import React from 'react';
import { Redirect } from 'react-router';

import authOptional from '../base/util/authOptional';
import authRequired from '../base/util/authRequired';
import catalog from '../catalog/routes';
import courseApplication from '../courseApplication/routes';
import enrollments from '../enrollments/routes';
import identity from '../identity/routes';
import members from '../members/routes';
import policies from '../policies/routes';
import settings from '../settings/routes';
import loadable from '../shared/utils/loadable';

const App = loadable(() => import('./App'));

// NOTE: The identity app is the only one that doesn't use App as a parent!
const IdentityApp = loadable(() => import('../identity/App'));

const routes = [{
	path: '/application',
	// NOTE: Auth wrappers added on page-by-page basis in courseApplication app
	component: App,
	routes: courseApplication,
}, {
	path: '/dashboard',
	component: authRequired(App),
	routes: enrollments,
}, {
	// NOTE: deprecated route
	path: '/enrollments',
	component: authRequired(App),
	routes: enrollments,
}, {
	path: [
		'/forgotpassword',
		'/forgot-password',
		'/invitations',
		'/login',
		'/mfa',
		'/register',
		'/register/terms-of-service',
		'/login-or-register', // NOTE: Deprecated route
		'/logout',
		'/oauth/redemption',
		'/passwordreset',
		'/password-reset',
		'/redirect/external',
	],
	component: authOptional(IdentityApp),
	routes: identity,
}, {
	path: '/members',
	component: authRequired(App),
	routes: members,
}, {
	path: '/settings',
	component: authRequired(App),
	routes: settings,
}, {
	path: '/policies',
	component: authOptional(App),
	routes: policies,
}, {
	path: '/',
	component: authOptional(App),
	routes: catalog,
}, {
	render: () => <Redirect to="/" />
}];

export default routes;
